"use strict";

exports.__esModule = true;
exports.default = void 0;
var _restArguments = _interopRequireDefault(require("./restArguments.js"));
var _isFunction = _interopRequireDefault(require("./isFunction.js"));
var _optimizeCb = _interopRequireDefault(require("./_optimizeCb.js"));
var _allKeys = _interopRequireDefault(require("./allKeys.js"));
var _keyInObj = _interopRequireDefault(require("./_keyInObj.js"));
var _flatten = _interopRequireDefault(require("./_flatten.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// Return a copy of the object only containing the allowed properties.
var _default = exports.default = (0, _restArguments.default)(function (obj, keys) {
  var result = {},
    iteratee = keys[0];
  if (obj == null) return result;
  if ((0, _isFunction.default)(iteratee)) {
    if (keys.length > 1) iteratee = (0, _optimizeCb.default)(iteratee, keys[1]);
    keys = (0, _allKeys.default)(obj);
  } else {
    iteratee = _keyInObj.default;
    keys = (0, _flatten.default)(keys, false, false);
    obj = Object(obj);
  }
  for (var i = 0, length = keys.length; i < length; i++) {
    var key = keys[i];
    var value = obj[key];
    if (iteratee(value, key, obj)) result[key] = value;
  }
  return result;
});